export default theme => ({
  header: {
    fontSize: 14,
    fontWeight: 400
  },
  list: {
    lineHeight: 1.6,
    padding: '0 15px'
  },
  item: {
    borderBottom: '1px solid #eee',
    padding: '10px 0'
  },
  author: {
    fontSize: 12
  },
  comment: {
    fontSize: 12,
    color: 'rgba(0, 0, 0, 65%)'
  }
});